import * as React from 'react';
import { INewsListItem } from 'src/Entities/News/NewsItem';
import { fetchNews } from 'src/helpers/api';
import NewsArchiveModalContainer from '../NewsModal/NewsArchiveContainer';
import NewsModalContainer from '../NewsModal/NewsModalContainer';
import { usePageModals } from 'src/shared/Modal';
import NewsTicker from '.';

type State = {
  news: INewsListItem[];
  pageIndex: number;
  isLoading: boolean;
};

const PAGE_SIZE = 4;

const NewsTickerContainer = () => {
  const modals = usePageModals();
  const [state, setState] = React.useState<State>({
    news: [],
    pageIndex: 0,
    isLoading: true,
  });
  const [isArchiveVisible, setIsArchiveVisible] = React.useState(false);
  const isFirstPage = React.useMemo(
    () => state.pageIndex === 0,
    [state.pageIndex],
  );
  const isLastPage = React.useMemo(
    () => state.pageIndex + 1 >= state.news.length - PAGE_SIZE,
    [state.pageIndex, state.news.length],
  );
  const news = React.useMemo(
    () => state.news.slice(state.pageIndex, state.pageIndex + PAGE_SIZE),
    [state.pageIndex, state.news],
  );

  const handleSelectItem = (id: number) => {
    modals.open((modal) => (
      <NewsModalContainer
        onCloseClick={modal.close}
        initialSelectedItemId={id}
        initialListPage={1}
        showExpired={false}
      />
    ), { namespace: 'newspanel' });
  };

  React.useEffect(() => {
    setState((prevState) => ({ ...prevState, isLoading: true }));

    fetchNews(1, 16)
      .then(({ newsList }) => {
        setState((prevState) => ({ ...prevState, news: newsList, isLoading: false }));
      });
  }, []);

  if (state.isLoading) {
    return null;
  }

  return (
    <>
      <NewsTicker
        className="px-10"
        news={news}
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        onItemClick={handleSelectItem}
        onArchiveClick={() => setIsArchiveVisible(true)}
        onPreviousPageClick={() => setState((prevState) => ({ ...prevState, pageIndex: prevState.pageIndex - PAGE_SIZE }))}
        onNextPageClick={() => setState((prevState) => ({ ...prevState, pageIndex: prevState.pageIndex + PAGE_SIZE }))}
      />
      {isArchiveVisible && (
        <NewsArchiveModalContainer
          onCloseClick={() => setIsArchiveVisible(false)}
        />
      )}
    </>
  );
};

export default NewsTickerContainer



// WEBPACK FOOTER //
// ./src/components/News/NewsTicker/NewsTickerContainer.tsx